import * as React from "react"
import ReactDOM from "react-dom/client"
import { initializeActivity } from "./checkout/activity"
import { ErrorBoundary } from "./ErrorBoundary"
import { App } from "./App"
import "./styles.css"

initializeActivity(import.meta.env.VITE_BOOKING_API_BASE_URL || "http://127.0.0.1:55421/functions/v1/booking-api", { presence: true })

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary><App /></ErrorBoundary>
  </React.StrictMode>,
)
